// extracted by mini-css-extract-plugin
export default {"Button":"button_Button__J8zZd","Small":"button_Small__aWpMl","Primary":"button_Primary__uo4qs","Success":"button_Success__Nf-Fr","Danger":"button_Danger__PpcSv"};